var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.08398C9.08333 7.08398 8.33333 7.83398 8.33333 8.75065C8.33333 9.66732 9.08333 10.4173 10 10.4173C10.9167 10.4173 11.6667 9.66732 11.6667 8.75065",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.416V12.916",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1583 5.93281C17.1583 4.90781 16.375 3.77448 15.4167 3.41615L11.2583 1.85781C10.5667 1.59948 9.43333 1.59948 8.74167 1.85781L4.58333 3.42448C3.625 3.78281 2.84167 4.91615 2.84167 5.93281V12.1245C2.84167 13.1078 3.49167 14.3995 4.28333 14.9911L7.86667 17.6661C9.04167 18.5495 10.975 18.5495 12.15 17.6661L15.7333 14.9911C16.525 14.3995 17.175 13.1078 17.175 12.1245V9.19115",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSecurity);
export default __webpack_public_path__ + "static/media/activeSecurity.69b9d97bbffb96a9d318ff576ccb7642.svg";
export { ForwardRef as ReactComponent };